import { render, staticRenderFns } from "./QuickNav.vue?vue&type=template&id=05690d92&scoped=true&"
import script from "./QuickNav.vue?vue&type=script&lang=js&"
export * from "./QuickNav.vue?vue&type=script&lang=js&"
import style0 from "./QuickNav.vue?vue&type=style&index=0&id=05690d92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05690d92",
  null
  
)

export default component.exports